import React, { useEffect, useState } from "react";
import { Calculator } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { money } from "@/components/finance/shared";

const ROLES = ["admin", "broker_manager", "finance_staff", "finance_manager"];

const Row = ({ label, value, testid, sub, strong, tone = "" }) => (
  <div className={`flex justify-between gap-4 py-1.5 ${strong ? "border-t border-slate-800 mt-1 pt-2.5" : ""}`}>
    <div>
      <div className={strong ? "text-sm font-medium text-slate-100" : "text-sm text-slate-400"}>{label}</div>
      {sub && <div className="text-[11px] text-slate-500">{sub}</div>}
    </div>
    <div data-testid={testid} className={`font-mono-ops ${strong ? "text-lg font-bold" : "text-sm"} ${tone}`}>{value}</div>
  </div>
);

export const CostSummary = ({ sh }) => {
  const { user } = useAuth();
  const allowed = ROLES.includes(user?.role);
  const [s, setS] = useState(null);
  useEffect(() => {
    if (allowed) api.get(`/shipments/${sh.id}/cost-summary`).then((r) => setS(r.data)).catch(() => setS(null));
  }, [sh.id, sh.updated_at, allowed]);
  if (!allowed || !s) return null;

  return (
    <div data-testid="cost-summary" className="glass-card rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2 font-display text-xl font-bold"><Calculator size={18} className="text-sky-400" /> Cost summary</div>
        {s.estimated && <span data-testid="cost-estimated" className="text-[10px] uppercase tracking-widest px-2 py-0.5 rounded border bg-amber-500/15 text-amber-300 border-amber-500/30">Estimate</span>}
      </div>
      <Row label="Cash advances (approved)" sub={`${s.cash_advance_count} request(s)`} value={money(s.cash_advances)} testid="cost-advances" />
      <Row label="Liquidated spending" sub={`Receipted ${money(s.receipted)} · Unreceipted ${money(s.unreceipted)}`} value={money(s.liquidated)} testid="cost-liquidated" />
      {s.unliquidated > 0 && <Row label="Not yet liquidated" sub="Counted at the advanced amount" value={money(s.unliquidated)} testid="cost-unliquidated" tone="text-amber-300" />}
      <Row label="Storage" value={money(s.storage)} testid="cost-storage" />
      <Row label="Total costs" value={money(s.total_costs)} testid="cost-total" strong />
      <Row label="Invoice total" sub={s.invoice_number ? `${s.invoice_number} · collected ${money(s.collected)}` : "No invoice yet"} value={money(s.invoice_total)} testid="cost-invoice" />
      <Row label="Profit" value={money(s.profit)} testid="cost-profit" strong tone={s.profit < 0 ? "text-rose-300" : "text-emerald-300"} />
      {s.estimated && <p className="text-[11px] text-slate-500 mt-3">This is an estimate until every cash advance is liquidated and approved and the invoice is created.</p>}
    </div>
  );
};
